import React from "react";
import { Route } from "react-router-dom";
import Register from "../auth/register";
import Login from "../auth/login";
import Logout from "../auth/logout";
import RegisterCompany from "../auth/RegisterCompany";
import AccountRegistration from "../auth/AccountRegistration";
import ForgetPassword from "../auth/ForgetPassword";
import VerifyUser from "../auth/VerifyUser";
import AppBar from "../appbar/AppBar";
import Tour from "../landingpage/tour/Tour";
import Pricing from "../landingpage/Pricing";
import NewPassword from "../auth/NewPassword";
import LandingPage from "../landingpage/LandingPage";
import CheckoutForm from "../auth/CheckoutForm";
import Footer from "../footer/footer";
import {Newfooter} from "../footer/Newfooter";

const authenticationRoutes = [
  <Route
    path="/"
    element={
      <>
        <AppBar />
        <LandingPage />
        <Footer />
      </>
    }
  />,
  <Route
    path="/tour"
    element={
      <>
        <AppBar />
        <Tour />
        <Newfooter />
      </>
    }
  />,
  <Route
    path="/pricing"
    element={
      <>
        <AppBar />
        <Pricing />
        <Footer />
      </>
    }
  />,

  <Route path="/register" element={<Register />} />,
  <Route path="/login" element={<Login />} />,
  <Route path="/logout" element={<Logout />} />,
  <Route path="/forget-password" element={<ForgetPassword />} />,
  <Route path="/register-company" element={<RegisterCompany />} />,
  <Route path="/account-registeration" element={<AccountRegistration />} />,
  <Route path="/verify-user" element={<VerifyUser />} />,
  <Route path="/new-password" element={<NewPassword />} />,
  <Route path="/payment" element={<CheckoutForm />} />,
];

export default authenticationRoutes;
